import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import Swal from "sweetalert2";


const ScheduledTasks = () => {

    const [tasks, setTasks] = useState([]);
    const [infoMessage, setInfoMessage] = useState("");
    const { jwtToken } = useOutletContext();
    const { userInfo } = useOutletContext();


    const { setAlertClassName } = useOutletContext();
    const { setAlertMessage } = useOutletContext();



    const navigate = useNavigate();

    useEffect(() => {
        if (jwtToken === "") {
            navigate("/");
            return
        }

        // headers for request
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken);

        // options for request
        const requestOptions = {
            method: "GET",
            headers: headers,
            credentials: "include"
        }
        // request to backend
        fetch(`${process.env.REACT_APP_BACKEND}/api/ar/scheduled-tasks`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                if (data.info) {
                    setInfoMessage(data.message);
                }
                if (data.error) {
                    setAlertClassName("alert-danger"); // show error class
                    setAlertMessage(data.message);
                    return
                } else {
                    setAlertClassName("d-none"); // hide alert if it was
                    setAlertMessage("");
                    setTasks(data);
                }
            })
            // in case of error log it
            .catch(err => {
                console.log(err);
            })
    }, [jwtToken, navigate, setAlertClassName, setAlertMessage]);


    const handleChangeStatus = (taskID) => {

        // create headers
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken);


        let method = "PATCH";

        let requestOptions = {
            method: method,
            headers: headers,
            credentials: "include",
        }

        // make a request
        fetch(`${process.env.REACT_APP_BACKEND}/api/ar/scheduled-tasks/change-status/${taskID}`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    setAlertClassName("alert-danger"); // show error class
                    setAlertMessage(data.message);
                    return
                } else {
                    setAlertClassName("d-none"); // hide alert if it is
                    setAlertMessage("");
                    // change task status 
                    const newTasks = tasks.map(task => {
                        if (task.id === taskID) {
                            return {
                                ...task,
                                activated: !task.activated,
                            };
                        }
                        return task
                    });
                    // Re-render new array
                    setTasks(newTasks);
                }
            })
            // in case of error log it
            .catch(err => {
                console.log(err);
            })

    }

    const handleDelete = (taskID) => {

        // ask user if he really wants to delete
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            // if confirmed
            if (result.isConfirmed) {

                // create headers
                const headers = new Headers();
                headers.append("Content-Type", "application/json");
                headers.append("Authorization", "Bearer " + jwtToken);


                let method = "DELETE";

                let requestOptions = {
                    method: method,
                    headers: headers,
                    credentials: "include",
                }

                // make a request
                fetch(`${process.env.REACT_APP_BACKEND}/api/ar/scheduled-tasks/${taskID}`, requestOptions)
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.error) {
                            setAlertClassName("alert-danger"); // show error class
                            setAlertMessage(data.message);
                            return
                        } else {
                            setAlertClassName("d-none"); // hide alert if it is
                            setAlertMessage("");
                            // delete report from reports  
                            setTasks(tasks.filter(item => item.id !== taskID));
                            Swal.fire(
                                'Deleted!',
                                'Your task has been deleted.',
                                'success'
                            )
                        }
                    })
                    // in case of error log it
                    .catch(err => {
                        console.log(err);
                    })
            }
        })
    }


    return (
        <div>
            <h2 className="text-center">Scheduled tasks</h2>
            <hr />
            <div><h5>Scheduled tasks limit: {tasks.length > 0 ? tasks.length : "0"} / {userInfo.scheduledTasksLimit}</h5></div>
            <div>
                <h4 className="text-center mt-5">{infoMessage}</h4>
            </div>
            {tasks.length > 0 &&
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>Task ID</th>
                            <th>Name</th>
                            <th>Time to complete</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tasks.map((m) => (
                            <tr key={m.id}>
                                <td>
                                    {m.id}
                                </td>
                                <td>
                                    {m.name}
                                </td>
                                <td>
                                    {m.time}
                                </td>
                                <td>

                                    {m.activated ? (
                                        <button onClick={() => handleChangeStatus(m.id)} className="btn btn-outline-success border-0 ms-2">
                                            <h6>Activated</h6>
                                        </button>
                                    ) : (
                                        <button onClick={() => handleChangeStatus(m.id)} className="btn btn-outline-danger border-0 ms-2">
                                            <h6>Deactevated</h6>
                                        </button>
                                    )}


                                    <button onClick={() => handleDelete(m.id)} className="btn btn-outline-danger ms-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash3" viewBox="0 0 16 16">
                                            <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                                        </svg>
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            }
        </div>
    )
}

export default ScheduledTasks;